export const updateReceptBookingEndpoint = '/berths/booking/update_reception' as const
